import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import { NotificationManager } from "react-notifications";
import {
  CustomSelect,
  FloatInput,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import uuid from "react-uuid";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";

import { getSite, getMBMEquipments } from "services/ConfigServices";
import styled from "styled-components";

import { usage as usagetxt } from "variables/patrimoine";
import { categoryData, energyData, consumptionpartmethodData } from "variables/lists/usage";

import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "5%",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "5%",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function UsageDialog(props) {
  const { closeModal, refetch, currentUsage, usageList } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;



  const [name, setName] = useState(currentUsage?.name || "");
  const [category, setCategory] = useState(currentUsage?.category || "");
  const [energy, setEnergy] = useState(currentUsage?.energy || "");
  const [associatedmeter, setAssociatedmeter] = useState(currentUsage?.associatedmeter || "");
  const [consumptionpartmethod, setConsumptionpartmethod] = useState(currentUsage?.consumptionpartmethod || "");
  const [consumptionpart, setConsumptionpart] = useState(currentUsage?.consumptionpart || "");
  const [points, setPoints] = useState(currentUsage?.points || []);
  const [equipments, setEquipments] = useState(currentUsage?.equipments || []);

  const [buttonDisabled, setButtonDisabled] = useState(true);


  const handleNameChange = (event) => { setName(event.target.value); };
  const handleCategoryChange = (event) => { setCategory(event.target.value); };
  const handleEnergyChange = (event) => {
    setEnergy(event.target.value);
    setAssociatedmeter('');
    setMeter('');
  };
  const handleConsumptionpartmethodChange = (event) => {
    setConsumptionpartmethod(event.target.value);
    setConsumptionpart('');
  };
  const handleConsumptionpartChange = (event) => { setConsumptionpart(event.target.value); };
  const handlePointsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setPoints(newArray);
  };
  const handleEquipmentsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setEquipments(newArray);
  };

  const [meter, setMeter] = useState([]);
  const selectedMeter = () => {
    let selected = {};
    if (meter !== undefined) {
      selected = meter;
    }
    return selected;
  };
  const handleMeterChange = (newValue) => {
    setMeter(newValue);
    if (newValue)
      setAssociatedmeter(newValue.id);
    else
      setAssociatedmeter('');
  };
  const [meterdata, setMeterdata] = useState([]);
  useEffect(() => {
    if (energy) {
      axios
        .get(
          getSite(chartIdGroup, "energy." + energy + ".meters"),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpMeterData = res.data?.detail?.energy[energy].meters?.map((data) => {
            return (
              { name: data.meternumber, id: data.meternumber }
            );
          });
          setMeterdata(tmpMeterData);
          if (associatedmeter) {
            let tmpmeter = tmpMeterData.find((o) => o.id === associatedmeter);
            setMeter(tmpmeter);
          }
        });
    }
  }, [energy]);


  const selectedPoint = () => {
    let selected = pointsData.filter((obj) =>
      points.includes(obj.id));
    return selected;
  };
  const [pointsData, setPointsData] = useState([]);
  useEffect(() => {
    if (chartIdGroup > 0) {
      axios
        .get(
          getMBMEquipments(chartIdGroup, 'all'),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpPointsData = res.data.points?.map((data) => {
            return (
              { name: data.name, id: data.id }
            );
          });
          setPointsData(tmpPointsData || []);
        });
    }
  }, [chartIdGroup]);


  const [equipmentsData, setEquipmentsData] = useState([]);
  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "equipments.equipmentlist"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpEquipmentsData = res.data?.equipments?.map((data) => {
          return (
            { name: data.name + '(' + data.devicename + ')', id: data.uuid }
          );
        });
        setEquipmentsData(tmpEquipmentsData || []);
      });
  }, [chartIdGroup]);
  const selectedEquipment = () => {
    let selected = [];
    if (equipmentsData)
      selected = equipmentsData.filter((obj) => equipments.includes(obj.id));
    return selected;
  };

  const classes = useStyles();

  const handleSubmit = (event) => {
    if (currentUsage) {
      let tmpusage = {
        ...currentUsage,
        name,
        category,
        energy,
        associatedmeter,
        consumptionpartmethod,
        consumptionpart,
        points,
        equipments,
      };
      let index = usageList.findIndex((item) => item.uuid === currentUsage.uuid);
      if (index >= 0) {
        usageList.splice(index, 1, tmpusage);
        updateUsageList(usageList);
      }
    }
    else {
      const newusage = {
        name,
        category,
        energy,
        associatedmeter,
        consumptionpartmethod,
        consumptionpart,
        points,
        equipments,
        'uuid': uuid(),
      };
      usageList.push(newusage);
      updateUsageList(usageList);
    }
    closeModal();
  };

  useEffect(() => {
    if (!name || !energy || !category)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const updateUsageList = async (usageListToSend) => {

    axios
      .put(
        getSite(chartIdGroup, "usage.usagelist"),
        usageListToSend
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Usage enregistré");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };


  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                isRequired
                inputTitle={usagetxt.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <CustomSelect
                isRequired
                inputTitle={usagetxt.category}
                selectValue={category}
                handleSelectValueChange={handleCategoryChange}
                data={categoryData}
              />
            </div>
            <div>
              <CustomSelect
                isRequired
                inputTitle={usagetxt.energy}
                selectValue={energy}
                handleSelectValueChange={handleEnergyChange}
                data={energyData}
              />
            </div>
            <div>
              <AutocompleteInputMeters
                inputMargin={"1rem 0rem 0rem"}
                specialWidth={"97%"}
                inputTitle={usagetxt.associatedmeter}
                selected={selectedMeter()}
                list={meterdata}
                handleChange={(_, newValue) =>
                  handleMeterChange(newValue)
                }
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={usagetxt.consumptionpartmethod}
                selectValue={consumptionpartmethod}
                handleSelectValueChange={handleConsumptionpartmethodChange}
                data={consumptionpartmethodData}
              />
            </div>
            {
              consumptionpartmethod !== 'iot' &&
              <div>
                <FloatInput
                  inputTitle={usagetxt.consumptionpart}
                  floatInput={consumptionpart}
                  handleFloatInputChange={handleConsumptionpartChange}
                  disabled={consumptionpartmethod === 'equipments'}
                />
              </div>
            }
            <div>
              <AutocompleteMultiselectInputById
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={usagetxt.equipments}
                selected={selectedEquipment()}
                list={equipmentsData}
                handleChange={handleEquipmentsChange}
              />
            </div>
            <div>
              <AutocompleteMultiselectInputById
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={usagetxt.iot}
                selected={selectedPoint()}
                list={pointsData}
                handleChange={handlePointsChange}
              />
            </div>

            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default UsageDialog;
